import { Component, inject, OnInit, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { LoaderService } from './core/services/loader.service';
import { LayoutComponent } from './layouts/main-layout/layout/layout.component';

@Component({
  selector: 'data-lens-root',
  imports: [LayoutComponent, LoaderComponent, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  readonly loaderService = inject(LoaderService);
  private readonly router = inject(Router);

  readonly showMainShell = signal(this.isMainShellRoute(this.router.url));

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        const url = (event as NavigationEnd).urlAfterRedirects;
        this.showMainShell.set(this.isMainShellRoute(url));
      });
  }

  private isMainShellRoute(url: string): boolean {
    const path = url.split('?')[0];
    if (path.startsWith('/login') || path.startsWith('/auth/') || path.startsWith('/select-org')) {
      return false;
    }
    return true;
  }
}
